import { useState } from "react";
import ShimmerScreen from "../../../../Layouts/ShimmerScreen";
import "./DiscussCommentBlockComponent.scss";
import _ from "lodash";

const DiscussCommentBlockComponent = (props) => {

    const {
        commentId, commentorName, commentDays,
        commentData, thumbsUpCount, thumbsDownCount,
        replyAction, avtarAction, likeAction,
        commentorID, isLoading,
        commentorImgURL, commentorAltText, isSelfDisLike,isSelfLike,
        hideReply, isShow
    } = props

    

    return (
        <>
            <div className="comment-section">
                <div className="avtar-logo">
                    {
                        isLoading ? 
                        <button
                            type="button"
                            className="reset-btn btn-avtar"
                        >
                            <ShimmerScreen 
                                case="circle"
                                width="3rem"
                                height="3rem"
                            />
                        </button>
                        :
                        <button
                            type="button"
                            className="reset-btn btn-avtar"
                            onClick={() => avtarAction(commentorID)}
                        >
                            {
                                commentorImgURL ?
                                <img className="" src={commentorImgURL} alt={commentorAltText} />
                                :
                                <div 
                                className={`title-logo d-flex justify-content-center align-items-center bk-grey cursor-pointer`}
                                >
                                    <p>{commentorAltText}</p>
                                </div>
                            }
                        </button>
                    }
                </div>
                <div className="comment-body">
                    <div className="body-title">
                        {
                            isLoading ?
                            <>
                                <div>
                                    <ShimmerScreen 
                                        case="rect"
                                        width="5rem"
                                        height="1rem"
                                    />
                                </div>
                                <span>|</span>
                                <span>
                                    {

                                    }
                                </span>
                            </>
                            :
                            <>
                                <div>{commentorName}</div>
                                <span>|</span>
                                <span>{commentDays}</span>
                            </>
                        }
                    </div>
                    <div className="body-main">
                        {
                            isLoading ?
                            <div className="w-100">
                                <ShimmerScreen 
                                    case="rect"
                                    width="15rem"
                                    height="1rem"
                                />
                                <div className="mt-2">
                                    <ShimmerScreen 
                                        case="rect"
                                        width="80%"
                                        height="1rem"
                                    />  
                                </div>
                                <div className="mt-2">
                                    <ShimmerScreen 
                                        case="rect"
                                        width="60%"
                                        height="1rem"
                                    />  
                                </div>
                            </div>
                            :
                            <>
                                {commentData}
                            </>
                        }
                    </div>
                    <div className="body-footer">
                        <div className="footer-btn-cmt thumbs-up">
                            {
                                isLoading ?
                                <ShimmerScreen 
                                    case="rect"
                                    width="1rem"
                                    height="0.9rem"
                                />  
                                : 
                                <>
                                    <span>{thumbsUpCount}</span>
                                    <button className={`${isSelfLike ? 'active' : ''} ${!isShow ? "cursor-not-allowed":""}`}
                                        onClick={() => {
                                            
                                            likeAction(commentId, 'like')
                                            
                                        }}
                                        disabled={!isShow}
                                    ></button>
                                </>
                            }
                        </div>
                        <div className="footer-btn-cmt thumbs-down">
                            {
                                isLoading ?
                                <ShimmerScreen 
                                    case="rect"
                                    width="1rem"
                                    height="0.9rem"
                                />  
                                : 
                                <>
                                    {/* <span>{thumbsDownCount}</span> */}
                                    <button className={`${isSelfDisLike ? 'active' : ''} ${!isShow ? "cursor-not-allowed":""}`}
                                        onClick={() => {
                                            likeAction(commentId, 'dislike')
                                        }}
                                        disabled={!isShow}
                                    ></button>
                                </>
                            }
                        </div>
                        {
                            (hideReply || isLoading) ? "" :
                            <button type="button" className={`reset-btn ${!isShow ? "cursor-not-allowed":""}`} onClick={() => replyAction(commentId)} disabled={!isShow}>
                                <div className="footer-btn-cmt msg-reply">
                                    <span>Reply</span>
                                    <button></button>
                                </div>
                            </button>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default DiscussCommentBlockComponent